import React from "react"
import Imgix from "react-imgix"
import PropTypes from "prop-types"
import { OutboundLink } from "gatsby-plugin-google-analytics"

import startingAt from "../images/overview/starting-at.svg"

const SellBlock = ({
  showStarting,
  children,
  cost,
  service,
  body,
  notes,
  image,
  link,
}) => {
  let costDisplay = ""
  if (cost && service) {
    costDisplay = (
      <div className="sell-block__cost">
        {cost}
        <small className="sell-block__service">
          {`+${service} service fee`}
        </small>
      </div>
    )
  }
  return (
    <div className="sell-block">
      <Imgix src={image} className="sell-block__image" />
      <div className="sell-block__content">
        {showStarting ? (
          <div className="start">
            <img className="start__image" src={startingAt} alt="Starting at" />
            <div className="start__text">$39/mo.</div>
          </div>
        ) : null}
        <div className="sell-block__header">{children}</div>
        {costDisplay}
        <div className="sell-block__body t5">{body}</div>
        <ul className="sell-block__notes">
          {notes.map((note) => (
            <li key={note} className="sell-block__note t2">
              {note}
            </li>
          ))}
        </ul>
        <OutboundLink href={link} className="cta">
          Buy Now
        </OutboundLink>
      </div>
    </div>
  )
}

SellBlock.propTypes = {
  showStarting: PropTypes.boolean,
  children: PropTypes.node.isRequired,
  cost: PropTypes.string,
  service: PropTypes.string,
  body: PropTypes.string.isRequired,
  notes: PropTypes.instanceOf(Array).isRequired,
  image: PropTypes.string.isRequired,
  link: PropTypes.string,
}

SellBlock.defaultProps = {
  showStarting: false,
  cost: "",
  service: "",
  link: "",
}

export default SellBlock
